import { Car, LookupStore } from "./LookupStore";
import "./QuickLookupElement.less";

type JumpMode = "tyre" | "rim";

export class QuickLookupElement extends HTMLElement { 
    static tag = "quick-lookup";
    private _results: HTMLElement;
    private _cars: Car[];
    
    connectedCallback() {
        if (!this.jumpMode)
            this.jumpMode = "rim";
            
        this.innerHTML = this.view();
        this._results = this.querySelector("[name=results]");

        this.addEventListener("input", this.onInput);
        this.addEventListener("keydown", this.onKeyDown);

        this.querySelector("input").focus();
    }

    public get jumpMode() {
        return this.getAttribute("jump-mode") as JumpMode;
    }

    public set jumpMode(value: JumpMode) { 
        this.setAttribute("jump-mode", value);
    }

   

    private onInput = async () => { 
        const query = this.querySelector("input").value;
        this._cars = await LookupStore.instance.lookup(query);

        
        this.determineActiveCar(query, this._cars);
        

        this._results.innerHTML = this._cars.map(this.resultView).join("");

        this.highlightActiveCar();
    }

    private _activeCar: Car;

    private highlightActiveCar = () => {
        const existingActiveCar = this.querySelector(".car[active]");
        if (existingActiveCar)
            existingActiveCar.toggleAttribute("active", false);

        if (!this._activeCar)
            return;

        const activeCar = this.querySelector(`[car-id="${this._activeCar.carId}"]`);
        
        if (activeCar) { 
            activeCar.toggleAttribute("active", true);
        }
    }

    private determineActiveCar = (query: string, cars: Car[]) => { 
        if (cars.length === 0) {
            this._activeCar = undefined;
            return;
        }
        
        this._activeCar = cars.filter(m => m.carId.toString() === query)[0];

        if (!this._activeCar) {
            this._activeCar = cars[0];
        }

        console.log("active car", this._activeCar);
    }

    private close = () => { 
        this.toggleAttribute("show", false);
        setTimeout(() => {
            this.remove();
        }, 300);
    }

    private onKeyDown = (event: KeyboardEvent) => { 

        switch (event.key) { 
            case "Escape":
                this.close();
                break;
            case "Enter":
                this.jumpToCar(this._activeCar);
                break;
            case "ArrowRight":
                this.jumpMode = "rim";
                break;
            case "ArrowLeft":
                this.jumpMode = "tyre";
                break;
            case "ArrowDown":
                this.navigateCar("down");
                break;
            case "ArrowUp":
                this.navigateCar("up");
                break;   
        }
    }

    private navigateCar(direction: "up" | "down") {
        const cars = this.querySelectorAll(".car");
        const activeCar = this.querySelector(`[car-id="${this._activeCar.carId}"]`);
        const activeCarIndex = Array.from(cars).indexOf(activeCar);

        if (direction === "down" && activeCarIndex === cars.length - 1)
            return;

        if (direction === "up" && activeCarIndex === 0)
            return;

        this._activeCar = direction === "up" ? this._cars[activeCarIndex - 1] : this._cars[activeCarIndex + 1];
        this.highlightActiveCar();
    }

    private jumpToCar = (car: Car) => { 
        if (!car) {
            return;
        }

        switch (this.jumpMode) { 
            case "rim":
                window.location.href = `https://r2.eurowheels.dk/warehouse/selectrims.aspx?m=car&CarID=${this._activeCar.carId}&CarEditionID=${this._activeCar.carEditionId}`;
                break;
            default:
                window.location.href = `https://r2.eurowheels.dk/warehouse/selecttyres.aspx?m=car&CarID=${this._activeCar.carId}&CarEditionID=${this._activeCar.carEditionId}`;
                break;
                
        }
    }

    private view = () => `
        <div>
            <div name="search">
                <input type=text placeholder="12345">
            </div>
           
            <div name="results"></div>
        </div>
    `;

    private resultView = (results: Car) => `
        <div class=car car-id="${results.carId}">
            <div class=car-id>${results.carId}</div>
            <div class=description>${results.brand} ${results.model}</div> 
            <button name=tyre type=button>${require("!!raw-loader?esModule=false!./Images/tire.svg")}</button>
            <button name=rim type=button>${require("!!raw-loader?esModule=false!./Images/rim.svg")}</button>
        </div>
    `;

    
}

customElements.define(QuickLookupElement.tag, QuickLookupElement);